module.exports = __webpack_public_path__ + "static/media/Karmilla-Regular.fa4fceb051cedb91f88f1e6d9fe10c07.woff";